import { render, staticRenderFns } from "./ConfigurazioneDeviceDeviceListComponent.vue?vue&type=template&id=23b8b122"
import script from "./ConfigurazioneDeviceDeviceListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneDeviceDeviceListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports